export { HttpLoaderFactory } from './http-loader.factory';
export { TranslationFallbackHandler } from './translation-fallback.provider';
export { TranslationParserHandler } from './translation-fallback.provider';


// WEBPACK FOOTER //
// ./src/translations/index.ts